<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { Button } from '@/components/ui/button'

const store = useStore()
const map = computed(() => store.getters['geo/getMap'])
const map2 = computed(() => store.getters['geo/getMap2'])
const is3DView = ref(false)

const toggleMapDimension = () => {
  is3DView.value = !is3DView.value

  if (is3DView.value) {
    map.value.easeTo({
      pitch: 75,
      bearing: 0,
      duration: 0
    })

    if (map2.value) {
      map2.value.easeTo({
        pitch: 75,
        bearing: 0,
        duration: 0
      })
    }
  } else {
    map.value.easeTo({
      pitch: 0,
      bearing: 0,
      duration: 0
    })

    if (map2.value) {
      map2.value.easeTo({
        pitch: 0,
        bearing: 0,
        duration: 0
      })
    }
  }
}
</script>

<template>
  <div class="flex items-center" v-if="map">
    <Button @click="toggleMapDimension" class="p-0 bg-white rounded w-[29px] h-[29px] shadow-[0_0_0_2px_#0000001a]">
      <span class="text-black font-bold">{{ is3DView ? '2D' : '3D' }}</span>
    </Button>
  </div>
</template>
